module.exports = __WEBPACK_EXTERNAL_MODULE_228__;


//////////////////
// WEBPACK FOOTER
// external {"root":"Vue","commonjs":"vue","commonjs2":"vue","amd":"vue"}
// module id = 228
// module chunks = 0